<template>
  <v-container>
    <v-card class="mx-auto mt-4 pa-4" max-width="">
      <v-card-title class="headline justify-center">
        Gráfico Dinâmico para Impressão
      </v-card-title>

      <v-card-text>
        <v-row v-if="(!vai_imprimir)">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="novoMes"
              label="Mês"
              dense
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="5">
            <v-text-field
              v-model="novoValor"
              label="Valor (R$)"
              dense
              outlined
              prefix="R$"
              @input="formataMoeda"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="2" class="d-flex align-center">
            <v-btn @click="adicionarItem" color="primary" small>
              Adicionar
            </v-btn>
          </v-col>
        </v-row>

        <v-simple-table class="mt-4 text-center" v-if="(!vai_imprimir)">
          <thead>
            <tr>
              <th class="text-center">Mês</th>
              <th class="text-center">Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dados" :key="index">
              <td>{{ item.mes }}</td>
              <td>R$ {{ item.valor }}</td>
              <td>
                <v-btn icon small @click="removerItem(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <div
          id="chart_div"
          class="mt-6 mx-auto"
          style="height:500px; text-align:center"
        ></div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn @click="imprimir" color="primary" small>
          Imprimir
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "GraficoDialog",

  data() {
    return {

      vai_imprimir: false,  
      novoMes: "",
      novoValor: "",
      dados: [
        { mes: "ABR", valor: "6.167,18" },
        { mes: "MAI", valor: "10.248,14" },
        { mes: "JUN", valor: "8.175,37" },
        { mes: "JUL", valor: "14.409,47" },
        { mes: "AGO", valor: "7.641,72" },
        { mes: "SET", valor: "14.676,00" },
        { mes: "OUT", valor: "17.278,11" },
        { mes: "NOV", valor: "5.727,89" },
        { mes: "DEZ", valor: "15.225,81" }
      ]
    };
  },

  mounted() {
    this.carregaGoogleCharts();
  },

  methods: {
    formataMoeda(valor) {
      if (!valor) return;

      let v = valor.replace(/\D/g, "");

      v = (v / 100).toFixed(2) + "";
      v = v.replace(".", ",");
      v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");

      this.novoValor = v;
    },

    moedaParaNumero(valor) {
      if (!valor) return 0;
      return parseFloat(valor.replace(/\./g, "").replace(",", "."));
    },

    adicionarItem() {
      if (!this.novoMes || !this.novoValor) return;

      this.dados.push({
        mes: this.novoMes.toUpperCase(),
        valor: this.novoValor
      });

      this.novoMes = "";
      this.novoValor = "";

      this.desenhaGrafico();
    },

    removerItem(index) {
      this.dados.splice(index, 1);
      this.desenhaGrafico();
    },

    carregaGoogleCharts() {
      if (!window.google) {
        const script = document.createElement("script");
        script.src = "https://www.gstatic.com/charts/loader.js";
        script.onload = () => this.desenhaGrafico();
        document.head.appendChild(script);
      } else {
        this.desenhaGrafico();
      }
    },

    desenhaGrafico() {
      if (!window.google) return;

      google.charts.load("current", { packages: ["corechart"] });

      google.charts.setOnLoadCallback(() => {
        const data = new google.visualization.DataTable();

        data.addColumn("string", "Mês");
        data.addColumn("number", "Valor");
        data.addColumn({ type: "string", role: "annotation" });

        const linhas = this.dados.map(i => {
          const numero = this.moedaParaNumero(i.valor);
          return [i.mes, numero, "R$ " + i.valor];
        });

        data.addRows(linhas);

        const options = {
          title: "FATURAMENTO DA LOCAÇÃO 2025",
          legend: { position: "bottom" },

          series: {
               // 0: { color: '#2196F3' }   // linha azul
               0: { color: 'grey' }   // linha azul
          },

          annotations: {
   
            alwaysOutside: true,
            highContrast: false,
            stem: {
                color: 'none'
            },

            textStyle: {
              fontSize: 14,
              color: 'white',
              bold:true,
              auraColor: 'none'
            },

            boxStyle: {
                // fill: '#EEE9E9'
                // fill: 'CornflowerBlue'
                fill: 'DimGrey'
            },

          },
        //   backgroundColor:'red',
          axisTitlesPosition:'out',
          lineWidth: 5,
          pointSize: 10,
          yAxis: { title: "Valores" }
        };

        const chart = new google.visualization.LineChart(
          document.getElementById("chart_div")
        );

        chart.draw(data, options);
      });
    },

    imprimir() {

      this.vai_imprimir = true
    //   return false  
      window.print();
    }
  }
};
</script>

<style scoped>
.v-card {
  text-align: center;
}

/* ---- EXIBIÇÃO NORMAL ---- */

#chart_div {
  width: 90%;
  margin: auto;
}

/* ---- IMPRESSÃO CORRIGIDA ---- */

@media print {

  @page {
    margin: 1cm;
  }

  body * {
    visibility: hidden;
  }

  #chart_div, #chart_div * {
    visibility: visible;
  }

  #chart_div {
    width: 100% !important;
    max-width: 19cm !important;     /* cabe em A4 */
    height: 600px !important;
    margin: auto !important;
    display: block !important;
  }
  

  /* v-card-title,
  v-card-actions,
  v-simple-table {
    display: none !important;
  } */
}
</style>
